import type { ConversationNodeIntegration } from 'lib-shared-types-api';

type Props = {
  node: ConversationNodeIntegration;
};

export function RoutedThroughIntegration({ node }: Props): JSX.Element {
  return (
    <>
      Integration <strong>{node.http_request_type}</strong> ·{' '}
      {node.variables?.length ? (
        <>
          Variables <strong>{node.variables.join(', ')}</strong>
        </>
      ) : (
        'No variables created'
      )}
    </>
  );
}
